import React, { useEffect, useState } from 'react'
import './HeroSection.scss'
import { Link } from 'react-router-dom'
import { array } from "../utils/helper";

const HeroSection = () => {
  const expertise = [
    { label: 'Web design and development', anchor: 'web-development' },
    { label: 'E-Commerce Solutions', anchor: 'ecommerce-solutions' },
    { label: 'Mobile apps development', anchor: 'mobile-applications' },
    { label: 'Consulting and Strategy', anchor: 'consulting-strategy' },
    { label: 'IT Support And Maintenance', anchor: 'it-support' },
  ]

  const [expertiseShown, setExpertiseShown] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setExpertiseShown(true)
    }, 2000)
    return () => clearTimeout(timer)
  })

  return (
    <section className="hero">
      <div className="hero-overlay">
        <div className="hero-content">
          <div className="container">
            <h1>
              <span>Your Software Projects</span>
              <span className="orange">Powered by Experts</span>
            </h1>
            <h2 className="subtitle fade-in-right-delayed-1s position-relative">Key Areas of Our Expertise</h2>

            <div className="expertise">
              {expertiseShown
                ? expertise.map((item, index) => (
                  <a href={`/services#${item.anchor}`}
                     key={index}
                     className="button position-relative fade-in-delayed-3s"
                     style={{ animationDelay: index * 200 + "ms" }}
                  >
                    <span>{item.label}</span>
                  </a>
                ))
                : null}
            </div>
            <a href="/contact" className='button section-cta fade-in-delayed-1s' style={{ animationDelay: '3s' }}>Let’s Talk About Your Business ➔</a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroSection
